import groq from 'groq'

export const AdvantagesQuery = groq`
  _type == 'Advantages' => {
    ...,
    icons[] {
      ...,
    },
  }
`
